import { RoleFn } from './role';

const role: RoleFn = ({ usuario_ativo }) => usuario_ativo.tipoResponsavel !== 'R';

export default role;
